<template src="./AdminAcademicSubcategoriesEdit.html"></template>

<script>
import AdminConfirmationModal from "./../../../AdminConfirmationModal/AdminConfirmationModal.vue";
import categoryService from "@/services/Category";
export default {
  name: "admin-academic-subcategories-edit",
  props: {
    subcategory: { type: Object }
  },
  data() {
    return {
      categories: [],
      view: "list",
      openModal: false,
      subcategoryName: "",
      category: null
    };
  },
  components: { AdminConfirmationModal },
  created() {
    this.getCategories();
  },
  mounted() {
    this.subcategoryName = this.subcategory.name;
  },
  methods: {
    async getCategories() {
      this.categories = await categoryService.getCategories();
      this.category = this.categories.find(
        category =>
          parseInt(category.id) === parseInt(this.subcategory.category.id)
      );
    },
    handleModal(state) {
      if (!this.subcategoryName.length) {
        this.$buefy.toast.open({
          duration: 5000,
          message: "Hace falta un nombre",
          position: "is-bottom",
          type: "is-danger"
        });
        this.openModal = false;
        return false;
      }
      if (!this.category) {
        this.$buefy.toast.open({
          duration: 5000,
          message: "Hace falta una categoría",
          position: "is-bottom",
          type: "is-danger"
        });
        this.openModal = false;
        return false;
      }
      this.openModal = state;
    },
    async confirm() {
      this.$store.dispatch("fetchLoading", true);
      try {
        await categoryService.updateSubcategory(
          {
            name: this.subcategoryName ? this.subcategoryName : "null",
            categoryId: this.category.id
          },
          this.subcategory.id
        );
        this.handleModal(false);
        this.subcategoryName = null;
        this.category = null;
        this.$buefy.toast.open({
          duration: 5000,
          message: "Subcategoría editada con éxito",
          position: "is-bottom",
          type: "is-success"
        });
      } catch (error) {
        this.$buefy.toast.open({
          duration: 5000,
          message: "Error al editar la subcategoría",
          position: "is-bottom",
          type: "is-danger"
        });
        console.error(error);
      }
      this.handleModal(false);
      this.$store.dispatch("fetchLoading", false);
    }
  },
  computed: {
    categoryImage() {
      if (this.categoryImageSelected) {
        return URL.createObjectURL(this.categoryImageSelected);
      }
      if (this.urlCategoryImage) {
        return this.urlCategoryImage;
      }
      return "";
    },
    categoryIcon() {
      if (this.categoryIconSelected) {
        return URL.createObjectURL(this.categoryIconSelected);
      }
      if (this.urlCategoryIcon) {
        return this.urlCategoryIcon;
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped src="./AdminAcademicSubcategoriesEdit.scss"></style>
